<template>
  <div class="main-content orderImport">

    <updateBlackList v-if="editableRecord"
                     :drug="editableRecord"
                     type="autolist"
                     :closeModal="closeModal"
    />

    <div class="card" v-if="countries">
      <div class="card-body">
        <div class="flex">
          <div class="form-group m-r-10 mb-0">
            <label for="">Выберите страну</label>
            <select class="form-control" v-model="selectedCountry">
              <option v-for="(name, index) in countries" :value="index">{{ name }}</option>
            </select>
          </div>
          <div class="flex">
            <vue-ladda @click="getDrugs" button-class="btn btn-info align-self-end"
                       data-style="zoom-in"
                       :loading="btnLoading">Просчитать список
            </vue-ladda>
          </div>
        </div>
      </div>
    </div>

    <!--    <div class="card" v-if="requestedDrugs || loading">-->
    <div class="card">
      <div class="card-body">

        <div class="text-center">
          <pulse-loader :loading="loading" :color="color"/>
        </div>

        <div v-if="false && drugs">
          <div id="printTable">
            <table class="table table-sm table-hover default_table table-striped">
              <thead>
              <tr>
                <th></th>
                <th width="50%">Препарат</th>
                <th>Запрос</th>
                <th class="hide_print">Детали</th>
                <th class="hide_print"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(drug, index) in drugs" :class="selectedCountry != drug.income_country_id ? 'bg-danger' : ''">
                <td>{{ index + 1 }}</td>
                <td>{{ drug.title }} ({{ drug.id }})</td>
                <td>{{ (storeRequest[drug.id] || 0) + getSumOfRequests(drug.id) }}</td>
                <td>
                  {{ storeRequest[drug.id] }}
                </td>
                <td>
                  {{ orderRequests[drug.id] }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="requestedDrugs">
          <div class="flex flex-end">
            <div class="m-r-10">
              <div class="form-check">
                <input class="form-check-input" @change="updateAllStats" type="checkbox" value="" id="ch11" v-model="showAllStatistics">
                <label class="form-check-label" for="ch11">Раскрыть все детали</label>
              </div>
            </div>
            <div>
              <button @click="printTable" class="btn btn-success">Печать</button>
            </div>
          </div>
          <div id="printTable">
            <table class="table table-hover default_table table-striped">
              <thead>
              <tr>
                <th></th>
                <th width="50%">Препарат</th>
                <th>Запрос</th>
                <th class="hide_print">Детали</th>
                <th class="hide_print"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(drug, index) in sortedDrugs()" :class="selectedCountry != drug.country ? 'bg-danger' : ''">
                <td>{{ index + 1 }}</td>
                <td>
                  {{ drug.name }} ({{ drug.id }})
                  <p class="pack_comment" v-if="drug.pack_set && drug.pack_set !== 1">Препарат комплектный: <span class="badge badge-info">1 комплект</span> - <strong>{{ drug.pack_set }}</strong>
                    (зав.уп.)</p>
<!--                  <p class="pack_comment" v-if="drug.pack_comment">{{ drug.pack_comment }}</p>-->
                  <p class="pack_box_comment" v-if="drug.pack_box_comment">{{ drug.pack_box_comment }}</p>
                </td>
                <td>{{ printQty(drug) }} <span v-html="printReserve(drug)"/></td>
                <td class="hide_print">
                  <div class="form-check">
                    <input class="form-check-input" @change="updateStatVisibility" type="checkbox" value="" :id="`defaultCheck${drug.id}`" v-model="drug.visibleStatistics">
                    <label class="form-check-label" :for="`defaultCheck${drug.id}`">Показать / скрыть</label>
                  </div>
                  <div v-if="drug.visibleStatistics">
                    <table class="table-bordered info_table">
                      <thead>
                      <tr>
                        <th></th>
                        <th v-for="(store) in storeNames">{{ store }}</th>
                      </tr>
                      </thead>
                      <tr>
                        <td>На складе</td>
                        <td v-for="(store, index) in storeNames">{{ inStore[index][drug.id] ? inStore[index][drug.id] : '' }}</td>
                      </tr>
                      <tr>
                        <td>Бронь</td>
                        <td v-for="(store, index) in storeNames">{{ (orderRequests[index] && orderRequests[index].total) ? orderRequests[index].total[drug.id] : '' }}</td>
                      </tr>
                      <tr>
                        <td>Запас</td>
                        <td v-for="(store, index) in storeNames">{{ storeRequest[index] ? storeRequest[index][drug.id] : '' }}</td>
                      </tr>
                    </table>
                  </div>
                </td>
                <td class="hide_print">
                  <dropdown-menu
                    v-model="drug.showDropDown"
                    :interactive="true"
                    :closeOnClickOutside="true"
                  >
                    <button class="btn btn-default dropdown-toggle1"><i class="icon-fa icon-fa-ellipsis-v"></i></button>
                    <div slot="dropdown">
                      <a @click="editRecord(drug)" class="dropdown-item pointer">Игнорирование</a>
                    </div>
                  </dropdown-menu>
                  <!--                  <button type="button" @click="editRecord(drug)" class="btn btn-info btn-xs"><i class="icon-fa icon-fa-info"></i></button>-->
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="text-right">
            <button @click="printTable" class="btn btn-success">Печать</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="ignoredDrugs.length">
      <div class="card-header"><h6>Препараты, которые игнорированны для просчета</h6></div>
      <div class="card-body">
        <table class="table table-sm table-hover table-striped">
          <thead>
          <tr>
            <th></th>
            <th>Препарат</th>
            <th>Запрос</th>
            <th class="hide_print">Детали</th>
            <th>Актуально до</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(drug, index) in sortedDrugs(true)" :class="selectedCountry != drug.country ? 'bg-danger' : ''">
            <td>{{ index + 1 }}</td>
            <td>
              {{ drug.name }} ({{ drug.id }})
              <p class="pack_comment" v-if="drug.pack_comment">{{ drug.pack_comment }}</p>
              <p class="pack_box_comment" v-if="drug.pack_box_comment">{{ drug.pack_box_comment }}</p>
            </td>
            <td>{{ printQty(drug) }} <span v-html="printReserve(drug)"/></td>
            <td class="hide_print">
              <div class="form-check">
                <input class="form-check-input" @change="updateStatVisibility" type="checkbox" value="" :id="`defaultCheck${drug.id}`" v-model="drug.visibleStatistics">
                <label class="form-check-label" :for="`defaultCheck${drug.id}`">Показать / скрыть</label>
              </div>
              <div v-if="drug.visibleStatistics">
                <table class="table-bordered info_table">
                  <thead>
                  <tr>
                    <th></th>
                    <th v-for="(store) in storeNames">{{ store }}</th>
                  </tr>
                  </thead>
                  <tr>
                    <td>На складе</td>
                    <td v-for="(store, index) in storeNames">{{ inStore[index][drug.id] ? inStore[index][drug.id] : '' }}</td>
                  </tr>
                  <tr>
                    <td>Бронь</td>
                    <td v-for="(store, index) in storeNames">{{ (orderRequests[index] && orderRequests[index].total) ? orderRequests[index].total[drug.id] : '' }}</td>
                  </tr>
                  <tr>
                    <td>Запас</td>
                    <td v-for="(store, index) in storeNames">{{ storeRequest[index] ? storeRequest[index][drug.id] : '' }}</td>
                  </tr>
                </table>
              </div>
            </td>
            <td>{{ moment(drug.black_list.actual_date, 'DD.MM.YYYY') }}</td>
            <td>
              <dropdown-menu
                v-model="drug.showDropDown"
                :closeOnClickOutside="true"
                :interactive="true"
              >
                <button class="btn btn-default dropdown-toggle1"><i class="icon-fa icon-fa-ellipsis-v"></i></button>
                <div slot="dropdown">
                  <a @click="editRecord(drug)" class="dropdown-item pointer">Игнорирование</a>
                </div>
              </dropdown-menu>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>


<script>

import Vue from 'vue'
import api from '@/api'
import moment from 'moment';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import updateBlackList from "./componetns/updateBlackList";
import DropdownMenu from '@innologica/vue-dropdown-menu'

import VueHtmlToPaper from 'vue-html-to-paper';

Vue.use(VueHtmlToPaper, {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    // 'https://unpkg.com/kidlat-css/css/kidlat.css',
    '/assets/css/print.css?id=2'
    // '<%= BASE_URL %>/'

  ]
});

export default {
  title: 'Автосписки (Заказ)',
  components: {
    PulseLoader,
    VueLadda,
    updateBlackList,
    DropdownMenu,
  },
  data() {
    return {
      show: false,
      drugs: null,
      editableRecord: null,
      requestedDrugs: null,
      drugNames: null,
      storeNames: null,
      inStore: null,
      storeRequest: null,
      orderRequests: null,
      color: '#5BBFDE',
      loading: true,
      visibleStatistics: {},
      countries: null,
      selectedCountry: null,
      btnLoading: false,
      showAllStatistics: false,
      ignoredDrugs: [],
    }
  },
  mounted() {
    this.getCities();
  },
  methods: {
    getSumOfRequests(drugId) {
      let qty = 0;
      if (this.orderRequests[drugId]) {
        qty += Object.values(this.orderRequests[drugId]).reduce((acc, qty) => acc + qty, 0)
      }
      return qty;
    },
    printQty(drug) {
      let qty = this.requestedDrugs[drug.id] * (-1);
      if (drug.pack_set && drug.pack_set != 1) {
        qty = (qty / drug.pack_set) + ' компл. (' + qty + ' зав.уп.)';
      }
      return qty;
    },
    updateStatVisibility() {
      this.drugNames = [...this.drugNames];
      this.ignoredDrugs = this.drugNames.filter((d) => d.black_list && d.black_list.is_active);
      // this.ignoredDrugs = [...this.ignoredDrugs];
    },
    updateAllStats() {
      this.drugNames.map((name) => {
        name.visibleStatistics = this.showAllStatistics;
      });
    },
    printReserve(drug) {
      // console.log(id);
      const {id} = drug;
      let reserve = 0;
      let diff = 0;
      Object.keys(this.orderRequests).forEach((storeId) => {
        if (!this.orderRequests[storeId].total) return;

        if (this.orderRequests[storeId].total[id]) {
          if (this.inStore[storeId][id]) {
            if (storeId == 3) {
              diff = (0 - +this.orderRequests[storeId].total[id]);
            } else {
              diff = (+this.inStore[storeId][id] - +this.orderRequests[storeId].total[id]);
            }
            if (diff < 0) reserve += (+diff * (-1));
          } else {
            reserve += +this.orderRequests[storeId].total[id];
          }
        }

      });

      if (this.inStore[3][id]) {
        reserve -= +this.inStore[3][id];
      }
      if (this.inStore[2][id]) {
        reserve -= +this.inStore[2][id];
      }

      const packSet = drug.pack_set && drug.pack_set != 1;
      const message = '(Бронь: ' + reserve + (packSet ? ' зав.уп.' : '') + ')';
      return reserve > 0 ? packSet ? '<p>' + message + '</p>' : message : '';
    },
    printTable() {
      this.$htmlToPaper('printTable');
    },
    async getCities() {
      let {data} = await api.index('/getCountries');
      this.countries = data.countries;
      this.selectedCountry = Object.keys(this.countries)[0]
      this.loading = false;
    },
    sortedDrugs(ignored = false) {
      if (ignored) {
        return _.orderBy(this.ignoredDrugs, 'name');
      } else {
        return _.orderBy(this.drugNames.filter((d) => !d.black_list || !d.black_list.is_active), 'name');
      }
    },
    async getDrugs() {
      this.btnLoading = true;
      this.loading = true;
      this.drugs = null;
      this.ignoredDrugs = [];
      this.requestedDrugs = null;
      let {data} = await api.post('/drugs/getDrugsForOrder', {
        countryId: this.selectedCountry
      });

      // this.storeRequest = data.storeRequest;
      // this.orderRequests = data.reserveRequest;
      // this.drugs = _.orderBy(data.drugs, 'title');
      //
      // this.loading = false;
      // this.btnLoading = false;
      // return;

      // const drugs = data.drugs;
      // this.drugs.forEach((name) => {
      //   name.visibleStatistics = false;
      //   name.showDropDown = false;
      // });
      this.drugNames = data.drugs.reduce((acc, d) => {
        acc.push({...d, visibleStatistics: false, showDropDown: false});
        return acc;
      }, []);

      this.requestedDrugs = data.requestedDrugs;
      this.storeNames = data.storeNames;
      this.orderRequests = data.requests;
      this.storeRequest = data.store_request;
      this.inStore = data.in_store_wo_transit;
      this.updateStatVisibility();
      this.loading = false;
      this.btnLoading = false;
    },
    moment: function (date, format) {
      if (!date) return;
      return moment(date).format(format);
    },
    closeModal(update = false) {
      if (update) {
        const index = this.drugNames.findIndex((d) => d.id === update.id);
        this.drugNames[index] = update;
        this.updateStatVisibility();
      }
      this.editableRecord = null;
    },
    editRecord(drug) {
      this.editableRecord = drug;
    },
  }

}

</script>

<style scoped>
.btn i {
  text-align: center;
}

.pack_comment,
.pack_box_comment {
  font-size: 11px;
  margin-bottom: 2px;
}

.pack_comment {
  color: #02026d;
}

.pack_box_comment {
  color: #0d6d02;
}
</style>

<style>
.orderImport .dropdown-menu a {
  color: #212529;
  text-decoration: none;
}

.orderImport .dropdown-menu {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, .15);
  right: 11px;
  left: auto;
}

.info_table th,
.info_table td {
  padding: 2px;
  text-align: center;
}

</style>
